import $ from 'jquery';
import { getInputValue } from '../utils/input';
import { matchesCriteria } from '../utils/criteria';
const ELEMENT_SELECTOR = '.js__hide-dropdown-options-on-target-value';
export class HideDropdownOptionsOnTargetValue {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        $elements.each((index, element) => {
            let $element = $(element);
            if ($element.hasClass('ui dropdown')) {
                $element = $element.find('select');
            }
            const $target = $($element.data('hide-options-target'));
            $target.on('change', event => {
                this.handleValueChange($(event.target), $element);
            });
            if ($element.data('hide-value-on-load')) {
                this.handleValueChange($target, $element);
            }
        });
    }
    static handleValueChange($target, $element) {
        const value = getInputValue($target);
        const { optionsHideCriteria, optionsToHide, inverseOptionsHideCriteria } = $element.data();
        const hideOptions = optionsHideCriteria.some((optionHideCriteria) => {
            return matchesCriteria(optionHideCriteria, value, inverseOptionsHideCriteria);
        });
        const indexOfOptionToHide = optionsHideCriteria.findIndex((option) => option === value);
        this.updateInput($element, hideOptions, indexOfOptionToHide >= 0 ? optionsToHide[indexOfOptionToHide] : []);
    }
    static updateInput($element, hideOptions, optionsToHide) {
        const $parent = $element.closest('.field:not(.js__toggle-element)').length
            ? $element.closest('.field:not(.js__toggle-element)')
            : $element.closest('.js__toggle-element');
        $element.parent().find('.item').show();
        optionsToHide.forEach(option => {
            $parent.find(`[data-value="${option}"]`).toggle(!hideOptions);
        });
    }
}
